import React from 'react'
import styles from './assets/TopPage.module.css'

import { Door } from 'apis/response_types'
import { Link } from 'react-router-dom'
import DefaultUserIcon from 'images/default_user_icon.jpg'
import DummyHeader from '../../images/dummy_header.jpg'
import { IMAGE_OPTIMIZER } from '../../constants'

interface Props {
  //   loading: boolean
  doors: Door[]
  //   title: string
  //   link?: string
  //   reduce_mobile: boolean
}

export default function DoorList(props: Props) {
  return (
    <ul className={`${styles['recommend-list']}`}>
      {props.doors.map((door, i) => {
        return (
          <li key={i} className={`${styles['recommend-list-item']}`}>
            <Link
              to={`/door/${door.id}`}
              className={`${styles['recommend-list-item-link']}`}
            >
              <div className={`${styles['recommend-list-item-inner']}`}>
                <div className={`${styles['recommend-item-image-wrap']}`}>
                  <div
                    className={`${styles['recommend-item-image']}`}
                    style={{
                      backgroundImage: `url(${
                        door.header
                          ? `${door.header}?${IMAGE_OPTIMIZER.size.thumbnails}`
                          : DummyHeader
                      })`
                    }}
                  ></div>
                </div>
                <div className={`${styles['recommend-item-content']}`}>
                  {door.free_trial_period && (
                    <div className={`${styles['recommend-free']}`}>
                      無料期間あり
                    </div>
                  )}
                  <p className={`${styles['recommend-item-title']}`}>
                    {door.title}
                  </p>
                  <div className={`${styles['recommend-user']}`}>
                    <div
                      className={`${styles['recommend-user-image']}`}
                      style={{
                        backgroundImage: `url(${door.icon || DefaultUserIcon})`
                      }}
                    ></div>
                    <p className={`${styles['recommend-user-name']}`}>
                      {door.username}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
